import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

window.Swiper = function (container, parameters) {
  parameters.loop = false;
  parameters.rewind = true;
  parameters.keyboard = true;
  return new Swiper(container, parameters);
};

const swiper = new window.Swiper('.swiper', {
  slidesPerView: 4,
  spaceBetween: 40,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  autoplay: {
    delay: 5000,
  },
  breakpoints: {
    '@0.00': {
      slidesPerView: 2,
    },
    '@0.75': {
      slidesPerView: 3,
    },
    '@1.00': {
      slidesPerView: 4,
    },
  },
});
